<ion-app class="background">
    <ion-router-outlet></ion-router-outlet>
</ion-app>
